import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faPrescription } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Button, Stack } from 'react-bootstrap';

import { SECTION_CTA_VAR, PGX_CTA_BTN_VAR } from '@constants/constants';

interface PGxButtonProps {
  handleClick: () => void;
}

export const PGxButton: React.FC<PGxButtonProps> = ({ handleClick }) => {
  const [loading, setLoading] = useState(false);

  return (
    <Stack direction='vertical' gap={4} className={`py-5 px-3 align-items-center border rounded-3 ${SECTION_CTA_VAR}`}>
      <p className='text-center fw-medium fs-5 lh-xs mb-0'>
        There is guidance available for your patient’s test results.
      </p>
      {loading ? (
        <Button variant={PGX_CTA_BTN_VAR} disabled={loading} active={loading}>
          {/* both disabled and active states are intentional to get the right styles */}
          <FontAwesomeIcon icon={faSpinner} className='fa-spin fa-lg me-2' />
          Please wait while we gather the most up to date medication information
        </Button>
      ) : (
        <Button
          variant={PGX_CTA_BTN_VAR}
          onClick={() => {
            setLoading(true);
            handleClick();
          }}
        >
          <FontAwesomeIcon icon={faPrescription as IconDefinition} className='fa-lg me-2' />
          Get started
        </Button>
      )}
    </Stack>
  );
};
